import { useIntlBetBuilder } from "../../intl-acca/useIntlBetBuilder.ts";
import { BetBuilderIntlPage } from "./BetBuilderIntlPage.tsx";

export function IntlBetBuilderRoute(): JSX.Element {
  const vm = useIntlBetBuilder();
  return (
    <BetBuilderIntlPage
      loading={vm.loading}
      error={vm.error}
      tournament={vm.tournament}
      slips={vm.slips}
    />
  );
}
